class VehicleVersion {
    constructor(id, infoAutoCode, name, brand, group) {
        this.id = id
        this.infoAutoCode = infoAutoCode
        this.name = name
        this.brand = brand
        this.group = group
    }

    static fromJson({ id, infoAutoCode, name, brand, group }) {
        return new VehicleVersion(id, infoAutoCode, name, brand, group)
    }
}

export default VehicleVersion
